
export default class Comment {
    constructor (dto) {
        this.id = 0
        this.documentId = 0
        this.autor = ''
        this.date = ''
        this.text = ''
        this.pageNumber = ''

        if (dto) {
            this.id = dto.CommentID
            this.documentId = dto.ObjectID
            this.autor = dto.Autor
            this.date = dto.Date
            this.text = dto.Text
            this.pageNumber = dto.PNum
        }
    }

    toDto () {
        return {
            CommentID: this.id,
            ObjectID: this.documentId,
            PNum: this.pageNumber,
            Text: this.text,
        }
    }
}
